import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=93fdab02&scoped=true&lang=pug&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=93fdab02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fdab02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('93fdab02', component.options)
    } else {
      api.reload('93fdab02', component.options)
    }
    module.hot.accept("./Verification.vue?vue&type=template&id=93fdab02&scoped=true&lang=pug&", function () {
      api.rerender('93fdab02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Verification.vue"
export default component.exports